import { OddsFormat } from '../types';

export const oddsFormatDefault: OddsFormat = 'american';
